import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

export type ClueConfig = {
  Year1: {
    variantId: string;
    alternateVariantId: string;
    price: number;
    discountedPrice: number;
    discountCode: string;
  };
};

export const ClueShopifyMap: Record<ShopifyStore, ClueConfig> = {
  [ShopifyStore.IN]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/43721380167750',
      alternateVariantId: 'gid://shopify/ProductVariant/43721380167750',
      price: 799,
      discountedPrice: 250,
      discountCode: 'DA28GBZKQ771',
    },
  },
  [ShopifyStore.AE]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/52870403293555',
      alternateVariantId: 'gid://shopify/ProductVariant/52870403293555',
      price: 149.99,
      discountedPrice: 34.99,
      discountCode: '73AEW8FGE8EC',
    },
  },
  [ShopifyStore.EU]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/56156431024502',
      alternateVariantId: 'gid://shopify/ProductVariant/56156431024502',
      price: 39.99,
      discountedPrice: 9.99,
      discountCode: '0DC7CX46SWW5',
    },
  },
  [ShopifyStore.GB]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/56130469855606',
      alternateVariantId: 'gid://shopify/ProductVariant/56130469855606',
      price: 24.99,
      discountedPrice: 7.99,
      discountCode: 'KA1ZBECARDVA',
    },
  },
  [ShopifyStore.ROW]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/43429038751804',
      alternateVariantId: 'gid://shopify/ProductVariant/43429038751804',
      price: 39,
      discountedPrice: 9.99,
      discountCode: 'HKK6SVAG0PF8',
    },
  },
  [ShopifyStore.US]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/42245095587936',
      alternateVariantId: 'gid://shopify/ProductVariant/42245095587936',
      price: 39,
      discountedPrice: 9,
      discountCode: '0G3WSZPJ3007',
    },
  },
  // FIXME: These need correct prices
  [ShopifyStore.AU]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/56130469855606',
      alternateVariantId: 'gid://shopify/ProductVariant/56130469855606',
      price: 24.99,
      discountedPrice: 7.99,
      discountCode: 'KA1ZBECARDVA',
    },
  },
  [ShopifyStore.CA]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/42245095587936',
      alternateVariantId: 'gid://shopify/ProductVariant/42245095587936',
      price: 39,
      discountedPrice: 9.99,
      discountCode: '0G3WSZPJ3007',
    },
  },
  [ShopifyStore.SA]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/56156431024502',
      alternateVariantId: 'gid://shopify/ProductVariant/56156431024502',
      price: 39.99,
      discountedPrice: 9.99,
      discountCode: '0DC7CX46SWW5',
    },
  },
  [ShopifyStore.MX]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/56156431024502',
      alternateVariantId: 'gid://shopify/ProductVariant/56156431024502',
      price: 39.99,
      discountedPrice: 9.99,
      discountCode: '0DC7CX46SWW5',
    },
  },
  [ShopifyStore.ZA]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/56156431024502',
      alternateVariantId: 'gid://shopify/ProductVariant/56156431024502',
      price: 39.99,
      discountedPrice: 9.99,
      discountCode: '0DC7CX46SWW5',
    },
  },
  // Clue is not offered in Japan. This entry exists only because ClueShopifyMap
  // is a full Record<ShopifyStore, ClueConfig>; the values are never rendered.
  // Gate on isClueAvailable() rather than reading these.
  [ShopifyStore.JP]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/56156431024502',
      alternateVariantId: 'gid://shopify/ProductVariant/56156431024502',
      price: 4500,
      discountedPrice: 1800,
      discountCode: '0DC7CX46SWW5',
    },
  },
};

/** Stores where the Clue bundle flow is not offered. */
const CLUE_UNSUPPORTED_STORES = new Set<ShopifyStore>([
  ShopifyStore.JP,
  // US + PR: the bundle is Ring AIR based, and AIR is not sold there
  // (COUNTRY_STORE_CONFIG marks unsupportedProducts.ring).
  ShopifyStore.US,
]);

/**
 * Whether the Clue bundle flow (?flow=clue, the addon and its discount code)
 * should be offered for a store.
 */
export const isClueAvailable = (store?: ShopifyStore | null): boolean =>
  !!store && !CLUE_UNSUPPORTED_STORES.has(store);
